import script from "./InvoiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDetail.vue?vue&type=style&index=0&id=9d8e614e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d8e614e"]])

export default __exports__